import { useState } from "react";
import { Modal, Box, Typography, Grid } from "@mui/material";

const ArtPieceModal = ({
  src,
  alt,
  title,
  description,
}: {
  src: string;
  alt: string;
  title?: string;
  description?: string;
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Grid
      item
      lg={3}
      md={3}
      sm={6}
      xs={12}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <img
        height="200"
        width="200"
        src={`${src}-thumbnail.jpg`}
        alt={alt}
        style={{ cursor: "pointer" }}
        onClick={handleOpen}
      />
      {title && (
        <Typography color="black" variant="h6" align="center">
          {title}
        </Typography>
      )}
      {description && (
        <Typography color="black" align="center">
          {description}
        </Typography>
      )}

      <Modal
        open={open}
        onClose={handleClose} // Closes the modal when clicking away
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          }}
          onClick={handleClose} // Ensures clicking outside the image closes the modal
        >
          <img
            src={`${src}.jpg`}
            alt={alt}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
            onClick={(e) => e.stopPropagation()} // Prevents closing when clicking on the image
          />
        </Box>
      </Modal>
    </Grid>
  );
};

export default ArtPieceModal;